import axios from "axios";
import { API_BASE_URL } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }) {
      const store = this;
      await fetchNext({ store: store });
    }
  }
};

async function fetchNext({ store }) {
  try {
    let response = await axios({
      method: "get",
      url: API_BASE_URL + `/biz-review-type`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    let bizReviewTypes = [];
    obj.forEach(function(bizReviewType) {
      bizReviewTypes.push({
        id: bizReviewType.id,
        name: bizReviewType.name,
        code: bizReviewType.code,
        configField: bizReviewType.configField,
      });
    });
    if (bizReviewTypes.length > 0) {
      store.dispatch("entities/bizReviewTypes/insertOrUpdate", {
        data: bizReviewTypes
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
  } catch (error) {
    store.dispatch("entities/settings/setIsOffline", true);
  }
}
